import { html, unsafeCSS, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./button-group.css?inline";
import "@/components/button";

@customElement("eko-button-group")
class ButtonGroup extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) direction: "horizontal" | "vertical" = "horizontal";
  @property({ reflect: true }) justify: "between" | "center" | "end" | "start" = "start";
  @property({ reflect: true, type: Boolean }) reverse = false;
  @property({ reflect: true }) size: "sm" | "md" | "lg" = "md";
  @property({ reflect: true }) variant: "default" | "equal" | "spaced" = "default";
  @property({ reflect: true, type: Boolean }) wrap = false;

  private handleSlotChange() {
    const buttons = this.querySelectorAll("eko-button");
    buttons.forEach((button: any) => {
      button.size = this.size;
    });
  }

  private renderButtonGroup(content: TemplateResult) {
    return html` <div class="eko-button-group-inner">${content}</div> `;
  }

  render() {
    const content = html`<slot @slotchange=${this.handleSlotChange}></slot>`;

    return this.renderButtonGroup(content);
  }

  updated(changedProperties: Map<string, any>) {
    if (changedProperties.has("size")) {
      this.handleSlotChange();
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-button-group": ButtonGroup;
  }
}

export default ButtonGroup;
